import { render, staticRenderFns } from "./SetMottoDialog.vue?vue&type=template&id=e653e744"
import script from "./SetMottoDialog.vue?vue&type=script&lang=js"
export * from "./SetMottoDialog.vue?vue&type=script&lang=js"
import style0 from "./SetMottoDialog.vue?vue&type=style&index=0&id=e653e744&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports